import React, { useState, useEffect } from 'react';
import { Box, Modal, InputBase, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/material/styles';
import { tokens } from '../../theme';
import { getMaquinasTejido } from '../../services/maquinasTejido.services';

const ModalMaquinasTejido = ({ open, onClose, onSelectMaquina }) => {
  const [maquinas, setMaquinas] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    { field: 'id', headerName: 'ID', flex: 0.3 },
    { field: 'descripcion', headerName: 'Máquina', flex: 2 },
    { field: 'id_usuario', headerName: 'Operador', flex: 2, cellClassName: "name-column--cell", },
  ];

  useEffect(() => {
    const fetchMaquinas = async () => {
      try {
        const response = await getMaquinasTejido();
        setMaquinas(response);
        setFilteredData(response);
      } catch (error) {
        console.error('Error al obtener máquinas:', error);
      }
    };

    if (open) fetchMaquinas();
  }, [open]);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);

    const filtered = maquinas.filter((maq) =>
      maq.nombre?.toLowerCase().includes(value.toLowerCase()) ||
      maq.descripcion?.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredData(filtered);
  };

  const handleRowClick = (params) => {
    onSelectMaquina(params.row);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-maquina-title"
      aria-describedby="modal-maquina-description"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.primary[600],
          padding: "10px",
          zIndex: 1500,
        }}
      >
        <Box m="0px">
          <Box display="flex" justifyContent="space-between" p={2}>
            <h1 id="modal-maquina-title">Buscar Máquina</h1>
            <Box
              display="flex"
              backgroundColor={colors.primary[400]}
              borderRadius="3px"
              height={"40%"}
              width={"40%"}
              marginTop={"3%"}
            >
              <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Buscar" value={searchValue} onChange={handleSearchChange} />
              <IconButton type="button" sx={{ p: 1 }}>
                <SearchIcon />
              </IconButton>
            </Box>
          </Box>
          <Box m="10px 0" height="70vh" width="80vh"
            sx={{
              "& .MuiDataGrid-root": { border: "none" },
              "& .MuiDataGrid-cell": { borderBottom: "none" },
              "& .name-column--cell": { color: colors.greenAccent[300] },
              "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[900], borderBottom: "none" },
              "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
              "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[900] },
              "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
            }}
          >
            <DataGrid
              rows={filteredData}
              columns={columns}
              onRowClick={handleRowClick}
              getRowId={(row) => row.id}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalMaquinasTejido;